// extracted by mini-css-extract-plugin
module.exports = {"main":"TrialDaysLeft_main__2Wa2o","content":"TrialDaysLeft_content__KqfPK","closeButton":"TrialDaysLeft_closeButton__2F77Z","warningIcon":"TrialDaysLeft_warningIcon__2JDvp"};